import classNames from 'classnames';

import { ancTypes } from 'composables/Product/ANCTypes/ANCTypesConstants';
import { ANCTypesFields } from 'composables/Product/ANCTypes/ANCTypesTypes';

type ANCTypesLabelsProps = {
  names: string[];
  activeType: ancTypes;
  ancTypesList: ancTypes[];
  fields: ANCTypesFields;
};
export const ANCTypesLabels = ({
  ancTypesList,
  activeType,
  names,
  fields,
}: ANCTypesLabelsProps) => {
  return (
    <div className="flex h-[349px] w-full flex-col-reverse pl-4 xxs:-mx-[7px] xxs:h-auto xxs:flex-row xxs:px-[7px]">
      {ancTypesList.map((type) => {
        return (
          <div
            key={`anc-types-description-${type}`}
            className="relative flex h-1/4 flex-col justify-center gap-1 xxs:block xxs:h-auto xxs:w-1/4 xxs:gap-0 xxs:pt-10 xxs:text-center"
          >
            {activeType === type && (
              <div className="absolute left-1/2 top-0 hidden h-[26px] -translate-x-1/2 flex-col items-center justify-end xxs:flex">
                <span className="absolute top-0 h-[24px] w-[5px] bg-beige-100 shadow-[1px_0_2px_-2px_rgba(0,0,0,0.2)_inset,-1px_0_2px_-2px_rgba(0,0,0,0.2)_inset]" />
                <span className="block h-1.5 w-3.5 rounded-full bg-beige-100 shadow-[0_2px_2px_0px_rgba(0,0,0,0.2)_inset]" />
              </div>
            )}
            <div>
              <ProductLabel
                className="xxs:hidden"
                type={type}
                activeType={activeType}
                names={names}
              />
            </div>
            <div className="font-semibold">{fields[`titleType${type}`].value}</div>
            <div className="flex flex-wrap gap-3 xxs:items-center xxs:justify-center xxs:pt-3">
              <ProductLabel
                className="hidden xxs:block"
                type={type}
                activeType={activeType}
                names={names}
              />
              <span className="text-sm text-beige">{fields[`subTitleType${type}`].value}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

type ProductLabelProps = {
  names: string[];
  type: ancTypes;
  activeType: ancTypes;
  className?: string;
};

const ProductLabel = ({ activeType, type, names, className }: ProductLabelProps) => {
  return activeType === type ? (
    <span
      className={classNames(
        'rounded-xl bg-blue-800 p-1.5 text-sm font-semibold text-white',
        className
      )}
    >
      {names[Number(type) - 1]?.replace('Jabra ', '')}
    </span>
  ) : null;
};
